import { render, staticRenderFns } from "./ActionChips.vue?vue&type=template&id=0e71f09c&"
import script from "./ActionChips.vue?vue&type=script&lang=js&"
export * from "./ActionChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports